import axios from "axios"
import {FLIGHT_PROVIDER_URL} from "../globals"
import {generateCRUDUrls, generateFinalUrl} from "./utils"


const URL = {
  FLIGHT_PROVIDER: generateCRUDUrls("/flight-provider"),

  LIST_AVAILABLE_ORDERS: "/flight-order-provider/list-available-orders/",
  ACCEPT_ORDER: "/flight-order-provider/{pk}/accept-order/",
  SUBMIT_ORDER: "/flight-order-provider/{pk}/submit-order/",
  DECLINE_ORDER: "/flight-order-provider/{pk}/decline-order/",
  DOWNLOAD_FIELDS: "/flight-order-provider/{pk}/download-fields/",
  LIST_FLIGHT_ORDER_ATTACHMENTS: "/flight-order-provider/{pk}/list-attachments/",
  DELETE_FLIGHT_ORDER_ATTACHMENT: "/flight-order-provider/{pk}/delete-attachment/",
}

export const axiosInstance = axios.create({
  baseURL: FLIGHT_PROVIDER_URL,
})

const generateCommonHeader = (authToken) => {
  return {
    Authorization: `Bearer ${authToken}`,
  }
}


//----------------- Endpoints -------------------//
export const listFlightProvider = (authToken) => {
  const url = generateFinalUrl(URL.FLIGHT_PROVIDER.LIST)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })
}


export const createFlightProvider = (authToken, flightProviderData) => {
  const url = generateFinalUrl(URL.FLIGHT_PROVIDER.CREATE)
  return axiosInstance.post(url,
    flightProviderData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })
}


export const updateFlightProvider = (authToken, pk, flightProviderData) => {
  const url = generateFinalUrl(URL.FLIGHT_PROVIDER.UPDATE, pk)
  return axiosInstance.put(url,
    flightProviderData,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })
}


export const listFlightOrders = (authToken) => {
  const url = generateFinalUrl(URL.LIST_AVAILABLE_ORDERS)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })
}


export const acceptOrder = (authToken, idFlightOrder) => {
  const url = generateFinalUrl(URL.ACCEPT_ORDER, idFlightOrder)
  return axiosInstance.post(url, {}, {
    headers: generateCommonHeader(authToken),
    withCredentials: true,
  })
}

export const submitOrder = (authToken, idFlightOrder) => {
  const url = generateFinalUrl(URL.SUBMIT_ORDER, idFlightOrder)
  return axiosInstance.post(url, {}, {
    headers: generateCommonHeader(authToken),
    withCredentials: true,
  })
}


export const declineOrder = (authToken, idFlightOrder) => {
  const url = generateFinalUrl(URL.DECLINE_ORDER, idFlightOrder)
  return axiosInstance.post(url, {}, {
    headers: generateCommonHeader(authToken),
    withCredentials: true,
  })
}


export const downloadFlightOrderFields = (authToken, pk, contentType, extraHeader) => {
  const url = generateFinalUrl(URL.DOWNLOAD_FIELDS, pk)
  return axiosInstance.post(url,
    {
      content_type: contentType,
    },
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
      ...extraHeader,
    },
  )
}


export const listFlightOrderAttachments = (authToken, pk) => {
  const url = generateFinalUrl(URL.LIST_FLIGHT_ORDER_ATTACHMENTS, pk)
  return axiosInstance.get(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    })
}


export const deleteFlightOrderAttachment = (authToken, pk, flightOrderAttachmentData) => {
  const url = generateFinalUrl(URL.DELETE_FLIGHT_ORDER_ATTACHMENT, pk, flightOrderAttachmentData)
  return axiosInstance.delete(url,
    {
      headers: generateCommonHeader(authToken),
      withCredentials: true,
    }, flightOrderAttachmentData)
}
